var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"m-app"}},[(_vm.isOpen)?_c('div',{staticClass:"zcModal"},[_c('div',{staticClass:"zcModal-content",style:(_vm.cumtomeStyle)},[(_vm.isCloseBTN)?_c('span',{staticClass:"close",on:{"click":_vm.closeModal}},[_vm._v("×")]):_vm._e(),_vm._t("child")],2)]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }